export default __webpack_public_path__ + "static/media/task.f3d3ebf3.png";